export default __webpack_public_path__ + "fa-sharp-light-300.ttf";